var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"position-relative"},[_vm._t("activator",null,null,_vm.listeners),_vm._v(" "),_c('div',{ref:"content",staticClass:"d-none"},[_vm._t("default")],2)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }